<template>
  <div class="list">
    <div v-if="yearDiscounts">
      <div @click="updateYearClick" class="update-year-item">
        <div class="year-main-container">
          <div class="first">
            {{
              $t("planUpgradePage.saveNow", {
                price: yearDiscounts.discountPrice,
              })
            }}
          </div>
          <div class="second">
            {{
              $t("planUpgradePage.saveNowTip", {
                planName: yearDiscounts.name,
              })
            }}
          </div>
        </div>
        <div class="right-icon"></div>
      </div>
      <div class="line"></div>
    </div>
    <div id="priceContainer">
      <div class="plan-row price-popular-container">
        <div class="plan-column"></div>
        <div
          class="plan-column"
          :class="{ 'plan-popular': item.mostPupular }"
          :key="item.name"
          v-for="item in priceList"
        >
          <template v-if="item.mostPupular">Most Popular</template>
        </div>
      </div>
      <div class="plan-row price-type-title">
        <div class="plan-column"></div>
        <div class="plan-column" :key="item.name" v-for="item in priceList">
          {{ item.name }}
        </div>
      </div>
      <div class="plan-row price-detail">
        <div class="plan-column"></div>
        <div
          class="plan-column"
          :key="item.name"
          v-for="(item, index) in priceList"
          :class="{
            'plan-popular': item.mostPupular,
            'no-right-border': popularBeforeStyle(item, index)[
              'no-right-border'
            ],
          }"
        >
          <div class="plan-price" v-show="item.currency !== 'USD'">
            <div class="num" style="position: relative; bottom: -4px">
              <div style="font-size: 20px; position: relative; bottom: 10px">
                {{ item.currency }}
              </div>
              <div style="font-size: 32px">
                {{ item.price }}<span class="mo">/m</span>
              </div>
            </div>
          </div>
          <div v-show="item.currency === 'USD'" class="plan-price">
            <span class="symbol">$</span>
            <span class="num">{{ item.price }}</span>
            <span class="mo">/m</span>
          </div>
          <div class="sub-btn your-plan" v-if="item.active">Your Plan</div>
          <div v-else class="sub-btn" @click="itemClick(item, index)">
            Select
          </div>
        </div>
      </div>
      <div
        class="plan-row limit-tip"
        v-for="permission in permissionList"
        :key="permission.key"
      >
        <div class="plan-column plan-title">{{ permission.title }}</div>
        <template v-for="(price, index) in priceList">
          <div
            :key="price.name"
            class="plan-column"
            :class="columnStyle(permission, price, index)"
            v-text="price[permission.key]"
          ></div>
        </template>
      </div>
      <div class="plan-row price-popular-bottom-container">
        <div class="plan-column"></div>
        <div
          class="plan-column"
          :class="{ 'plan-popular': item.mostPupular }"
          :key="item.name"
          v-for="item in priceList"
        ></div>
      </div>
    </div>
    <div
      class="bottom-des"
      v-if="showPriceTip"
      :style="{ 'padding-right': `${(6 - priceList.length) * 180}px` }"
    >
      All Prices are in USD.
    </div>
    <div class="member-des-title">
      <div class="header-title">
        Instagram official limitations apply to all Apphi plans
      </div>
    </div>
    <des2 class="member-des"></des2>
    <div class="member-des-title">
      <div class="header-title">
        {{ $t("myPlanPage.teamMember.whatMemberTitle") }}
      </div>
    </div>
    <member-des class="member-des"></member-des>
    <cancel-modal
      v-if="showCancelModal"
      @close="showCancelModal = false"
    ></cancel-modal>
  </div>
</template>

<script>
import { pricingPackageList as planBg } from "../../../../const/plan";
import { mapGetters } from "vuex";
import {
  CURRENT_USER_PLAN_LIST_SIMPLE,
  CURRENT_USER_INFO_SIMPLE,
} from "../../../../store/mutation-types";
import moment from "moment";
import MemberDes from "../../upgrade/des/Index.vue";
import Des2 from "../../upgrade/des2/Index.vue";
import { dateFormat } from "../../../../utils/plugin_helper";
import CancelModal from "../cancel/Cancel";
export default {
  name: "ActivePricingPackageComponent",
  components: { MemberDes, CancelModal, Des2 },
  data() {
    return {
      showCancelModal: false, // 是否显示取消弹出框
      planBg,
      memberDesOpen: false,
    };
  },
  computed: {
    ...mapGetters({
      planList: CURRENT_USER_PLAN_LIST_SIMPLE,
      user: CURRENT_USER_INFO_SIMPLE,
    }),
    /**
     * 年费优惠信息
     */
    yearDiscounts() {
      // 判断当前用户是不是月付用户，如果是则显示年付优惠信息，否则不显示
      if (this.user.plan.price === 0) {
        return null;
      }
      if (this.user.plan.billingInterval === 12) {
        return null;
      }
      const currentPlan = this.planList.find((p) => p.active);
      if (!currentPlan) {
        return null;
      }
      return {
        name: currentPlan.name, // 当前付费计划名称
        currentPlan,
        discountPrice: `$${
          (currentPlan.billingCycles[1].totalUsdPriceNum -
            currentPlan.billingCycles[0].totalUsdPriceNum / 12) *
          12
        }`, // 优惠价格
      };
    },
    permissionList() {
      if (this.planList && this.planList.length > 0) {
        return this.planList[0].permissionList;
      }
      return [];
    },
    // 2019.12.14 显示美金支付标识
    showPriceTip() {
      const first = this.planList[0];
      return first.currency === "USD";
    },
    /** 计算价格列表 */
    priceList() {
      return this.planList;
    },
  },
  methods: {
    /**
     * 升级年费点击
     */
    updateYearClick() {
      this.$emit("selected", {
        ...this.yearDiscounts.currentPlan,
        type: "year",
      });
    },
    popularBeforeStyle(price, index) {
      let result = {};
      const planIndex = Number(index);
      // 如果发现价格的一下是most popular则下一行右侧没有线
      if (planIndex !== this.planList.length - 1) {
        // 最后一个不校验
        const nextIsPopular = this.planList[planIndex + 1].mostPupular;
        if (nextIsPopular) {
          result["no-right-border"] = true;
        }
      }
      return result;
    },
    /**
     * 计算列的样式
     */
    columnStyle(permission, price, index) {
      let result = {};
      if (price[permission.key] !== "✗") {
        result.have = true;
        result["no-have"] = false;
      } else {
        result.have = false;
        result["no-have"] = true;
      }
      // ✓ 或者 ✗ 则加粗
      if (price[permission.key] === "✓" || price[permission.key] === "✗") {
        result["bold"] = true;
      }
      // mostpupular 显示特殊样式
      if (price.mostPupular) {
        result[" plan-popular"] = true;
      }
      const style = this.popularBeforeStyle(price, index);
      result = { ...result, ...style };
      return result;
    },
    /**
     * 用户点击条目点击事件
     * @param item 单条记录
     */
    async itemClick(item, index) {
      // 点击支付清空paypal info 信息
      // 如果全部可点击，点击的还是free且当前激活状态不是free则弹提示
      if (!item.active && item.price === 0) {
        // 判断是否已进行过取消
        if (this.user.plan.cancelTime) {
          // your-xxx-planyearly变量-will-change-to-free-plan-on-may-30-2019
          const date = dateFormat({
            date: moment(this.user.plan.currentPeriodEnd),
            format: "MMM DD, YYYY",
          });
          const text = this.$t("planUpgradePage.cancelPlanAgainText", {
            planName: this.user.plan.nameWithInterval,
            date,
          });
          await this.$alert.show({
            title: this.$t("common.cancelled"),
            text: text,
            yesText: this.$t("common.ok"),
          });
          return;
        }
        const date = dateFormat({
          date: moment(this.user.plan.currentPeriodEnd),
          format: "MMM DD, YYYY",
        });
        const cancelText = this.$t("planUpgradePage.cancelPlanText", {
          planName: this.user.plan.nameWithInterval,
          date,
        });
        await this.$confirm.show({
          title: this.$t("planUpgradePage.cancelTitle"),
          text: cancelText,
          cancelText: this.$t("common.cancel"),
        });
        this.showCancelModal = true;
        return;
      }
      // 2021.8.25 当前订阅为VIP PLAN且vip PLAN已经不存在则不进行降级验证
      const currentPlanIndex = this.planList.findIndex(
        (p) => p.name === this.user.plan.name
      );
      const currentVipPlan =
        currentPlanIndex === -1 && this.user.plan.name === "VIP";
      if (currentVipPlan) {
        this.$emit("selected", { ...item });
        return;
      }
      // 如果发现用户在进行降级操作，弹出提示
      const activeIndex = this.planList.findIndex((i) => i.active);
      // TODO paymentMethod=6则说明是apple pay订阅则不弹出任何降级提示 没找到当前订阅则说明是历史的坑 说明当时选了plus权限 则start不能订阅 （删除 '|| activeIndex === -1&& index === 1' 这行）
      if (
        this.user.paymentMethod !== 6 &&
        (index < activeIndex || (activeIndex === -1 && index === 1))
      ) {
        // 如果当前订阅是stripe就可以进入订阅页面
        if (this.user.paymentMethod === 1) {
          this.$emit("selected", { ...item });
        } else {
          await this.$confirm.show({
            title: this.$t("planUpgradePage.downgradePlanTitle"),
            text: this.$t("planUpgradePage.downgradePlanText"),
            yesText: this.$t("common.contactUs"),
            cancelText: this.$t("common.cancel"),
          });
          window.open(process.env.VUE_APP_CONTACT_US, "_blank");
        }
        return;
      }
      this.$emit("selected", { ...item });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import "../../../../assets/style/theme.less";

#priceContainer {
  border-radius: 5px;
  font-family: "SF Pro Text", "SF Pro Icons", "Helvetica Neue", "Helvetica",
    "Arial", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  letter-spacing: 0.5px;
  line-height: 21px;
}

#priceContainer .plan-row {
  display: table;
}

#priceContainer .plan-row .plan-column {
  display: table-cell;
  width: 180px;
  box-sizing: border-box;
  &:first-child {
    width: 230px;
  }
}

#priceContainer .plan-row .plan-column.no-right-border {
  border-right: none !important;
}

#priceContainer .plan-row.price-type-title .plan-column {
  border-right: 1px solid white;
  height: 50px;
  line-height: 50px;
  background: #e72955;
  color: white;
  text-align: center;
  font-size: 18px;
  font-weight: 500;
}

#priceContainer .plan-row.price-detail .plan-column {
  vertical-align: middle;
  text-align: center;
  height: 153px;
  border-right: 1px solid rgba(190, 190, 190, 0.5);
  border-bottom: 1px solid rgba(190, 190, 190, 0.5);
}

#priceContainer .plan-row.price-detail .plan-column .plan-price {
  position: relative;
}

#priceContainer .plan-row.price-detail .plan-column .plan-price .symbol {
  font-size: 24px;
  position: relative;
  top: -8px;
}

#priceContainer .plan-row.price-detail .plan-column .plan-price .num {
  font-size: 36px;
}

#priceContainer .plan-row.price-detail .plan-column .plan-price .mo {
  font-size: 20px;
}

#priceContainer .plan-row.limit-tip:hover .plan-column {
  background: rgba(190, 190, 190, 0.1);
}

#priceContainer .plan-row.limit-tip:hover .plan-column.plan-popular {
  background: rgba(221, 31, 75, 1) !important;
}

#priceContainer .plan-row.limit-tip .plan-column {
  height: 47px;
  vertical-align: middle;
  text-align: center;
  font-size: 14px;
  border-right: 1px solid rgba(190, 190, 190, 0.5);
  border-bottom: 1px solid rgba(190, 190, 190, 0.5);
  padding: 5px 10px;
}

#priceContainer .plan-row.limit-tip .plan-column.plan-title {
  text-align: right;
}

#priceContainer .plan-row.limit-tip .plan-column:first-child {
  border-left: 1px solid rgba(190, 190, 190, 0.5);
}

#priceContainer .plan-row.limit-tip .plan-column.bold {
  font-weight: 600;
}

#priceContainer .plan-row.limit-tip .plan-column.have {
  color: #e72955;
  white-space: pre-line;
}

#priceContainer .plan-row.limit-tip .plan-column.no-have {
  color: #8c8c8c;
}

#priceContainer .plan-row.price-popular-container .plan-column {
  border-radius: 5px 5px 0 0;
  font-size: 20px;
  background: transparent;
  color: transparent;
  height: 50px;
  line-height: 50px;
  border-right: 1px solid white;
  text-align: center;
  color: #f7e71b !important;
  font-weight: 500;
}

#priceContainer .plan-row.price-popular-bottom-container .plan-column {
  border-radius: 0 0 5px 5px;
  height: 8px;
}

#priceContainer .plan-row.price-type-title .plan-column:first-child {
  background: transparent;
}

#priceContainer .plan-row.price-type-title .plan-column:nth-child(2) {
  border-radius: 5px 0 0 0;
}

#priceContainer .plan-row.price-type-title .plan-column:last-child {
  border-radius: 0 5px 0 0;
  border-right-width: 0;
}

.sub-btn {
  width: 150px;
  height: 32px;
  line-height: 32px;
  margin-top: 24px;
  border-radius: 4px;
  color: white;
  text-align: center;
  display: inline-block;
  cursor: pointer;
  background: #e72955;
  box-sizing: content-box !important;
  border: 2px solid #e72955;
}

.sub-btn.your-plan {
  color: #e72955;
  border: solid 2px transparent !important;
  background: white;
  cursor: auto;
}

.sub-btn.your-plan:hover {
  opacity: 1;
}

.plan-popular.plan-column {
  border-radius: 0;
  background: #e72955 !important;
  color: white !important;
  border-right: 1px solid white !important;
  border-bottom: 1px solid white !important;
}

.plan-popular .sub-btn {
  border: solid 2px white;
  color: white !important;
  background: transparent;
}

.sub-btn:hover {
  opacity: 0.7;
}

.bottom-des {
  font-size: 14px;
  color: #bebebe;
  margin-top: 40px;
  text-align: right;
}

.rtl .list .update-year-item .right-icon {
  transform: rotate(180deg);
}

.list {
  width: @price-width;

  .update-year-item {
    width: 100%;
    background-position: center;
    border-radius: 8px;
    color: white;
    font-weight: 600;
    padding: 10px 18px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-image: url("../../../../../public/images/payment/Bg@3x.png");
    background-size: cover;
    background-repeat: no-repeat;
    cursor: pointer;

    &:hover,
    &:active {
      opacity: 0.7;
    }

    .year-main-container {
      text-align: initial;
      flex: 1;

      .first {
        font-size: 20px;
      }

      .second {
        font-size: 15px;
      }
    }

    .right-icon {
      background-image: url("../../../../../public/images/payment/Disclosure_Indicator@3x.png");
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      height: 15px;
      width: 10px;
    }

    &:active {
      opacity: 0.7;
    }
  }

  .line {
    border-bottom: 1px solid @border-color;
    height: 1px;
    margin: 15px 0;
  }

  .price-package-item:first-child {
    margin-top: 0 !important;
  }

  .member-des-title {
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 32px;

    .header-title {
      font-weight: bolder;
      font-size: 20px;
    }

    .down-image {
      width: 16px;
      height: 10px;
      background-image: url("../../../../../public/images/active/navigation_icon@3x.png");
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
    }

    .up {
      transform: rotate(180deg);
    }
  }
  .member-des {
    margin-top: 10px;
    width: @price-width;
  }
}
</style>
